import api, { ResponsePayloadWithData } from '.';

export type UserSchoolYear = {
  startYear: number;
  endYear: number;
  isCurrent: boolean;
  hasPassed: boolean;
};

export async function fetchUserSchoolYears() {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<UserSchoolYear[]>>('/studio/user/school-years');

  return data;
}
